import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue'
import Keys from '@/constant/key'


const maxDate = 1000*60*60*24*93 

export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryDetail',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

const start_time = ref('')
const end_time = ref('')
const disabledStartDate = (date) => { // 返回不可用日期
    return date.getTime() > Date.now()
}
const disabledEndDate = (date) => { // 返回不可用日期
        const startDate = new Date(start_time.value).getTime();
        return date.getTime() > Date.now() || start_time.value && date.getTime() > startDate + maxDate
    }
const onExport = () => {
    if(!start_time.value || !end_time.value){
        return proxy.$message({ type: 'error', message: '请选择开始日期和结束日期' })
    }

    window.open(`${Keys.baseUrl}/channel/report_apply_for_kf?start_time=${start_time.value}&end_time=${end_time.value}`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "mb15",
    shadow: "hover"
  }, {
    header: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", {
        class: "card-header",
        style: {"font-size":"14px","font-weight":"bold"}
      }, [
        _createElementVNode("span", null, "订单报表")
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_el_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "下单时间：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                class: "filter-item",
                modelValue: start_time.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((start_time).value = $event)),
                "value-format": "YYYY-MM-DD",
                "disabled-date": disabledStartDate,
                placeholder: "开始日期"
              }, null, 8, ["modelValue"]),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filter-divider" }, " -- ", -1)),
              _createVNode(_component_el_date_picker, {
                class: "filter-item",
                modelValue: end_time.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((end_time).value = $event)),
                "value-format": "YYYY-MM-DD",
                "disabled-date": disabledEndDate,
                placeholder: "结束日期(包含当天)"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                style: {"margin-left":"10px"},
                type: "primary",
                onClick: onExport
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})